import { render, staticRenderFns } from "./Hotzapp.vue?vue&type=template&id=63a75ae0&scoped=true&"
import script from "./Hotzapp.vue?vue&type=script&lang=js&"
export * from "./Hotzapp.vue?vue&type=script&lang=js&"
import style0 from "./Hotzapp.vue?vue&type=style&index=0&id=63a75ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a75ae0",
  null
  
)

export default component.exports